module.exports = __webpack_public_path__ + "img/1 (1).98b5e563.jpg";